import ActionButton from 'components/ActionButton';
import React, { useState } from 'react';
import styles from './index.module.scss';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { Error } from 'components/message/Error';
import { createCategory } from 'services';
import { showError } from 'utils';

const validationSchema = yup.object().shape({
  description: yup.string().required('Name is required'),
  sort: yup.number(),
  taxPercent: yup.number(),
  storageClass: yup.string(),
});

type FormData = {
  description: string;
  sort: number;
  taxPercent: number;
  storageClass: string;
};

const CreateCategory = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const { register, handleSubmit, errors } = useForm<FormData>({ resolver: yupResolver(validationSchema) });
  const { categoryGroupId } = props.match.params;
  
  const createCategoryFn = handleSubmit(async(values) => {
    setLoading(true);
    const { description, sort, storageClass, taxPercent } = values;
    const data = {
      groupId: categoryGroupId,
      description,
      sort,
      storageClass,
      taxPercent,      
    };
    try {
      const response = await createCategory(data);
      props.history.replace(`/category/${response.objectId}`);
    } catch (e) {
      showError(e);
      setLoading(false);
    }
  });
  
  return (
    <div className={styles['main-container']}>
      <div className={styles['header']}>
        <div className={styles['heading']}>Create a New Category</div>
      </div>
      <div className={styles['category-inputs-section']}>
        <div className={styles['input-group']}>
          <div className={styles['label']}>Name</div>
          <input
            name={'description'}
            ref={register}
            disabled={loading}
            className={'form-control'}
          />
          {errors.description && <Error message={errors.description.message} />}
        </div>        
        <div className={styles['input-group']}>
          <div className={styles['label']}>Tax Percent</div>
          <input
            name={'taxPercent'}
            ref={register}
            type={'number'}
            disabled={loading}
            className={'form-control'}
          />
          {errors.taxPercent && <Error message={errors.taxPercent.message} />}
        </div>        
        <div className={styles['input-group']}>
          <div className={styles['label']}>Sort</div>
          <input
            name={'sort'}
            type={'number'}
            ref={register}
            disabled={loading}
            className={'form-control'}
          />
          {errors.sort && <Error message={errors.sort.message} />}
        </div>        
        <div className={styles['input-group']}>
          <div className={styles['label']}>Storage Class</div>
          <input
            name={'storageClass'}
            ref={register}
            disabled={loading}
            className={'form-control'}
          />
          {errors.storageClass && <Error message={errors.storageClass.message} />}
        </div>              
      </div>
      <div className={styles['footer']}>
        <ActionButton
          text={'Cancel'}
          active={!loading}
          isLoading={false}
          onClick={() => props.history.goBack()}
          customClass={styles['cancel']}
        />
        <ActionButton
          text={'Create'}
          active={!loading}
          isLoading={loading}
          onClick={createCategoryFn}
        />
      </div>
    </div>
  );
};

export { CreateCategory };